<template>
  <Auth :auth="auth">
    <template v-slot:default>
      <el-switch v-bind="$attrs" v-on="$listeners">
      </el-switch>
    </template>

    <template v-slot:denied>
     <el-switch v-bind="$attrs" v-on="$listeners" disabled>
      </el-switch>
    </template>
  </Auth>
</template>

<script>
  import Auth from './Auth'
  export default {
    name: 'l-auth-switch',
    components: {
      Auth
    },
    props: {
      auth: {
        type: String,
        required: true
      }
    }
  }
</script>